// extracted by mini-css-extract-plugin
export var closeButton = "_5-5";
export var container = "_5-0";
export var contentContainer = "_5-1";
export var desktop = "_5-2";
export var fullModalImage = "_5-6";
export var mobile = "_5-3";
export var withImage = "_5-4";